import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function fetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_METADATAFILES_FETCHING:
      return true;
    case actions.SET_METADATAFILES:
      return false;
    default:
      return state;
  }
}
